import React, { useState, useContext } from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Checkbox from "../../../../../components/Checkbox";
import { GlobalState } from "../../../../../App";

const Row = ({ item, value, onChange, up, indexVal }) => {

  const [visibleActions, setVisibleActions] = useState(false);

  const [showPlaceHolder, setShowPlaceHolder] = useState(true);

  const { collSelecProdsList, setCollSelecProdsList, CURRENCY } = useContext(GlobalState)

  React.useEffect(() => {
    setTimeout(() => {
      setShowPlaceHolder(false)
    }, 100);
  }, [])

  const handleClick = async (clickedVal, i) => {
    if (!collSelecProdsList.includes(clickedVal.id)) {
      setCollSelecProdsList((oldData) => [...oldData, clickedVal.id])
    } else {
      setCollSelecProdsList(collSelecProdsList?.filter(data => {
        if (data !== clickedVal.id) {
          return data
        }
      }))
    }
  }

  return (
    <>
      <div
        key={indexVal}
        className={styles.row}
        onMouseLeave={() => setVisibleActions(false)}
      >

        <div className={styles.col}>
          <Checkbox
            id={item?.id}
            onChange={
              () => {
                handleClick(item, indexVal)
              }
            }
            value={item?.selected}
          />
        </div>

        <div className={styles.col}>
          <div
            className={styles.item}
          >
            <div className={styles.preview}>
              {
                showPlaceHolder ?
                  <img
                    srcSet={`/images/content/placeholderImg.png 2x`}
                    src={'/images/content/placeholderImg.png'}
                    alt="Product"
                  />
                  :
                  <img
                    srcSet={`${item.data.images} 2x`}
                    src={item.data.images}
                    alt="Product"
                  />
              }

            </div>
            <div className={styles.details}>
              <div className={styles.product}>{item?.product ? item?.product?.data?.titleEn : item.data.titleEn}</div>
              <div className={styles.product}>{item?.product ? item?.product?.data?.titleAr : item.data.titleAr}</div>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.label}>Sku</div>
          <div className={cn(styles.sales, styles.skuContainer)}>
            <div className={styles.number}>{item?.product ? item.data.sku : item.data.sku}</div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.label}>Category</div>
          <div className={styles.sales}>
            <div className={styles.number}>{item?.product ? item?.product?.data?.category : item.data.category}</div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.label}>Price</div>
          <div className={styles.sales}>
            <div className={styles.number}>{CURRENCY} {item?.product ? item?.product?.data?.price : item.data.price}</div>
          </div>
        </div>


        <div className={styles.col}>
          <div className={styles.label}>Qty</div>
          <div className={styles.sales}>
            <div className={styles.number}>{item.data.quantity ? item.data.quantity : 0}</div>
          </div>
        </div>


        <div className={styles.col}>
          <div className={styles.label}>Status</div>
          <div className={styles.sales}>
            {item.data.status === "On Sale" ? (
              <div className={cn("status-green", styles.status)}>{item.data.status}</div>
            ) : item.data.status === "Archived" ? (
              <div className={cn("status-yellow", styles.status)}>{item.data.status}</div>
            ) : item.data.status === "Out Of Stock" && (
              <div className={cn("status-red", styles.status)}>{item.data.status}</div>
            )
            }
          </div>
        </div>

      </div>

    </>
  );
};

export default Row;
